module.exports = __webpack_public_path__ + "img/GA.e554f938.svg";